<template>
  <item-base
    :route-name="routeName"
    icon="wrench"
  >
    APIテスト
  </item-base>
</template>

<script>
import ItemBase from './Base'

export default {
  components: {
    ItemBase
  },

  data () {
    return {
      routeName: 'api-test'
    }
  }
}
</script>
